// Author:Rakesh,
// CreateDate:12-1-2024



import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Config } from 'datatables.net';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { GenericSocketServiceService } from 'src/app/services/generic-socket-service.service';
import { GlobalStoreService } from 'src/app/services/global-store.service';
import { LoggerService } from 'src/app/services/logger.service';
import { loadAdvisorData } from 'src/app/state/actions/advisors.actions';
import { loadCorporateData } from 'src/app/state/actions/corporates.actions';
import { loadMemberData } from 'src/app/state/actions/members.actions';
import { selectLanguageData } from 'src/app/state/selectors';
import { selectAdvisorData } from 'src/app/state/selectors/advisors.selector';
import { selectCorporateData } from 'src/app/state/selectors/corporates.selector';
import { selectMemberData } from 'src/app/state/selectors/member.selector';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
declare var $: any;

import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { handleAmountonUI } from 'src/app/common-functions';

declare var $: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public displayStyle: any
  loginame: any;
  finalResults: any;
  role: any;
  userName: any;
  email: any;
  userInfo:any;
  portalInfo:any;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();
  members: any = [];
  membersData$: Observable<any>;
  brokerList: any = [];
  advisorData$: Observable<any>;
  clientList: any = [];
  corporateData$: Observable<any>;
  accessToken:any;
  reminderTime: any;
  currentMonth: String = '';
  dashboardUrls: any = [];
  selectedDashboardIndex: number = 0;
  totalArrearsAmount:any = 0;

  constructor(
    private logger: LoggerService,
    private elementRef: ElementRef,
    private http: HttpClient,
    private socket: GenericSocketServiceService,
    private globalStoreService: GlobalStoreService,
    private sanitizer: DomSanitizer,
    private store: Store<{ languageData: [], memberData: [], corporateData: [], advisorData: [] }>
  ) {
    this.languageData$ = store.select(selectLanguageData);
    this.membersData$ = store.select(selectMemberData);
    this.advisorData$ = store.select(selectAdvisorData);
    this.corporateData$ = store.select(selectCorporateData);
   }
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    language: {
      searchPlaceholder: 'Search here...',
    },
  };
  arrearsData: any;
  dtTrigger: Subject<any> = new Subject<any>();
  paymentForm = new FormGroup({
    cutomerId: new FormControl,
    PublicApiKey: new FormControl,
    SuccessUri: new FormControl,
    FailUri: new FormControl,
    FirstName: new FormControl,
    LastName: new FormControl,
    email: new FormControl,
    CardNumber: new FormControl,
    ExpirationMonth: new FormControl,
    ExporationYear: new FormControl,
    cvv: new FormControl,

    // signature:["", Validators.required],
    nameonthecard: new FormControl,

    aptcheck: new FormControl,
    streetaddress: new FormControl,
    streetaddressline2: new FormControl,
    city: new FormControl,
    province: new FormControl,
    postalcode: new FormControl,
    recaptchaReactive: new FormControl,
  });

  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Dashboard');
    },100)
    this.accessToken = sessionStorage.getItem('accessToken');
    var monthMinusOneName =  moment().subtract(0, "month").startOf("month").format('MMMM');
    this.currentMonth = monthMinusOneName + " " + new Date().getFullYear().toString()

    console.log(this.socket)
    this.dashboardUrls = JSON.parse(sessionStorage.getItem('dashboardUrls')??'[]');
    console.log('this.dashboardUrls', this.dashboardUrls);
    
    this.dashboardUrls = this.dashboardUrls?.map(url => ({
      name: url?.name,
      url: this.sanitizer.bypassSecurityTrustResourceUrl(url?.url)
    }));
    // this.dashboardUrls = []
    // this.dashboardUrls.push({name:"Dummy",url:""});
    console.log('this.dashboardUrls', this.dashboardUrls);
    this.getLanguageTokens();
    // this.getclientList();
    // this.getBrokerList();
    // this.getCoporateList();
    // this.getRemainders();

    this.role = sessionStorage.getItem('role');
    this.userName = sessionStorage.getItem('adminName');
    this.email = sessionStorage.getItem('loginname');
    this.loginame = sessionStorage.getItem("loginname")

    var s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "../assets/js/main.js";
    this.elementRef.nativeElement.appendChild(s);

    this.finalResults = JSON.parse(sessionStorage.getItem("signinResults"))
    this.userInfo = this.finalResults?.userInfo
    this.portalInfo = this.finalResults?.portalInfo
    if(Object.keys(this.globalStoreService.getCustomerFormConfig()).length==0){
      this.globalStoreService.setFormConfig('customer','en')
    }
    // if(this.globalStoreService.getMemberDetails().length==0){
      // this.globalStoreService.setMemberDetails()
    // }
  }
  public getLanguageTokens(){
    // let body= {
    //   "project":"Admin Portal",
    //   "url":"Dashboard"
    // }
    // this.http
    // .post('https://languageengineapi.aitestpro.com/string/project-url-strings',body, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // })
    // .subscribe(
    //   (response: any) => {
    //     console.log(response)
    //     this.lang = {};
    //     this.languageData = response.strings
    //     this.selectedLanguage = sessionStorage.getItem("language")
    //     for (let token of response.strings) {
    //       this.lang[token.key] = token[this.selectedLanguage];
    //     }
    //     console.log(this.lang)
    //   })

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        },0)
      }
    })


  }

  public getclientList(){
    this.store.dispatch(loadMemberData());

    this.membersData$ = this.store.select(state => state.memberData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.membersData$.subscribe(data => {
      if(data){
        console.log(data)
        if (data?.memberData == undefined || Object.keys(data.memberData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if(this.members.length>0){
          return;
        }
        const role = sessionStorage.getItem('role');
        if (role == 'ADMINISTRATOR') {
          // this.members = decompress(data.memberData);
          this.members = data.memberData;
          this.members = this.members.map(res=>{
            return {
              ...res,
              isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
            }
          })
        } else {
          this.members = data.memberData.map(res => {
            return {
              ...res,
              username: res.user?.username,
              primaryPhone: res?.contactInformations?.[0]?.primaryPhone || '',
              isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
            };
          });
        }

        setTimeout(() => {
          this.members.sort((a, b) => {
            const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

            if (order[a.status] !== order[b.status]) {
              return order[a.status] - order[b.status];
            }
            const result = a.firstName.localeCompare(b.firstName);
            return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
          });
        },0);
      }
  })}

  public getBrokerList() {
    this.store.dispatch(loadAdvisorData());
    this.advisorData$ = this.store.select(state => state.advisorData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );
    this.advisorData$.subscribe(data => {
      if (data) {
        console.log(data)
      if (data?.advisorData == undefined || Object.keys(data.advisorData).length <= 0) {
        console.log('No data to process', new Date().toISOString());
        return;
      }
      if(this.brokerList.length>0){
        return;
      }

      const role = sessionStorage.getItem('role');
      if(role=='ADMINISTRATOR'){
        this.brokerList = data.advisorData
        // this.brokerList = decompress(decompress(data.advisorData))
      }else{
        this.brokerList = data.advisorData
      }
      this.brokerList = this.brokerList.map((broker)=>{
        return{
          ...broker,
          published: !broker.published || broker.published == undefined || broker.published == null ? 'Inactive' : 'Active'
        }
      })
      setTimeout(()=>{
        this.brokerList.sort((a, b) => {
          const order = { true: 1, false: 2, };
          if (order[a.status] !== order[b.status]) {
            return order[a.status] - order[b.status];
          }
          return a.name.trim().localeCompare(b.name.trim());
        });
      },0)
      } else {
        console.error('Observable returned undefined');
      }
    })
  }


  public getRemainders() {
    let endPoint = '/reminders/today'
      
          this.http.get(environment.apiUrl + '/api/ap' + endPoint, {
            headers: {
              Authorization: 'Bearer ' + this.accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe(async (response: any) => {
            if(response.length > 0){
            this.reminderTime = moment(response[0].reminderTime).format('MM-DD-YYYY')
            console.log(response)
            Swal.fire({
              title: 'Info',
              html: `
                <div>
                  <p><strong>Reminder Text:</strong> ${response[0].reminderText}</p>
                  <button id="showSnoozeDate" class="btn btn-primary">Snooze Reminder</button>
                  <button id="stopReminder" class="btn btn-danger">Stop Reminder</button>
                  <div id="snoozeDateContainer" style="display: none; margin-top: 10px;">
                    <input type="date" id="snoozeDateInput" class="form-control">
                    <button id="updateReminder" class="btn btn-success mt-2">Update Reminder</button>
                  </div>
                </div>
              `,
              showCancelButton: false,
              showConfirmButton: false,
              didOpen: () => {
                // Add event listener to the "Show Snooze Date" button
                const showSnoozeDateButton = document.getElementById('showSnoozeDate');
                const stopRemainderButton = document.getElementById('stopReminder');
                const snoozeDateContainer = document.getElementById('snoozeDateContainer');
            
                if (showSnoozeDateButton && snoozeDateContainer) {
                  showSnoozeDateButton.addEventListener('click', () => {
                    snoozeDateContainer.style.display = 'block'; // Show the snooze date input and update button
                  });
                }

                if (stopRemainderButton) {
                  stopRemainderButton.addEventListener('click', () => {
                    this.completeReminder(response[0].id).subscribe(
                      (updateResponse) => {
                        Swal.fire({title: "Info", text: "Reminder stopped successfully"});
                      },
                      (error) => {
                        Swal.fire('Error', 'Failed to update reminder.', 'error');
                      }
                    );
                  });
                }
            
                // Add event listener to the "Update Reminder" button
                const updateReminderButton = document.getElementById('updateReminder');
                const snoozeDateInput:any = document.getElementById('snoozeDateInput');
            
                if (updateReminderButton && snoozeDateInput) {
                  updateReminderButton.addEventListener('click', () => {
                    const snoozeDate = snoozeDateInput.value;
            
                    if (!snoozeDate) {
                      Swal.fire('Error', 'Please select a snooze date.', 'error');
                      return;
                    }
            
                    // Call your API or service to update the reminder with the new snooze date
                    this.updateReminderSnoozeDate(response[0].id, snoozeDate).subscribe(
                      (updateResponse) => {
                        Swal.fire({title: "Info", text: "Reminder updated successfully"});
                      },
                      (error) => {
                        Swal.fire('Error', 'Failed to update reminder.', 'error');
                      }
                    );
                  });
                }
              },
            });
          }
          }
           )
  }


  updateReminderSnoozeDate(reminderId: number, snoozeDate: string) {
    const payload = {
      snoozeDate: moment(snoozeDate).format('YYYY-MM-DD')
    };

    let endPoint = `/api/ap/set-snooze/${reminderId}`
  
    // Replace with your actual API endpoint
    return this.http.post(environment.apiUrl + endPoint, payload,{
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    });
  }


  completeReminder(reminderId: number) {
    // Replace with your actual API endpoint
    let endPoint = `/api/ap/complete-reminder/${reminderId}`
    return this.http.get(environment.apiUrl + endPoint,{
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    });
  }


  public getCoporateList(){
    this.store.dispatch(loadCorporateData());
    this.corporateData$ = this.store.select(state => state.corporateData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );
    this.corporateData$.subscribe(data => {
      if (data) {
        console.log(data)
      if (data?.corporateData == undefined || Object.keys(data.corporateData).length <= 0) {
        console.log('No data to process', new Date().toISOString());
        return;
      }
      if(this.clientList.length>0){
        return;
      }

      const role = sessionStorage.getItem('role');
      if (role == 'ADMINISTRATOR') {
        // this.clientList = decompress(data.corporateData)
        this.clientList = data.corporateData
      } else {
        this.clientList = data.corporateData.map(res => {
          return {
            ...res,
            formsLength: res.forms?.length || 0
          }
        })
      }
      setTimeout(()=>{
        const sortedList = [...this.clientList].sort((a, b) => {
          const order = { true: 1, false: 2, cancelled: 3 };
          if (order[a.status] !== order[b.status]) {
            return order[a.status] - order[b.status];
          }
          return a.name.trim().localeCompare(b.name.trim());
        });
        this.clientList = sortedList;
      },0)
      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  public closePopup() {
    this.displayStyle = "none"
  }
 
  public  getReportsForArrears(){
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(
        `${
          environment.apiUrl
        }/api/ap/get-arrears-report/0/${'all'}`,
        {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        }
      )
      .subscribe({
        next: (res: any) => {
          console.log(res);
          $('#DataTables_Table_1').dataTable().fnDestroy();
          let copyData = res.data;
          let modifiedData:any = []
          for(let i = 0; i < res.data.length; i++){
            let data:any = res.data[i];
            data.invoiceAmount2 = handleAmountonUI(data?.invoiceAmount ?? 0);
            modifiedData.push(data)
          }
          let finalData = res.data.forEach((item:any) => {
            item.invoiceAmount2 = handleAmountonUI(item?.invoiceAmount ?? 0);
          })
 
         
          finalData = modifiedData;
          console.log(finalData);
 
 
          this.totalArrearsAmount = '$'  + handleAmountonUI(copyData.reduce((sum, item) => sum + (parseFloat(item.invoiceAmount) || 0), 0));
          this.arrearsData = finalData;
          this.dtTrigger.next(null);
        },
        error: (error) => {
          console.log(error);
        },
      });
  }
 
    downloadArrears(): void {
      console.log('this.arrearsData',this.arrearsData)
      const worksheetData = this.arrearsData.map((client, index) => {
        return {
          'Item': index + 1,
          'Customer ID': client?.customerId ?? '-',
          'Customer Name': client?.customerObj?.firstName + ' ' + client?.customerObj?.lastName || '-',
          'Company name': client?.customerObj?.broker?.name ?? '',
          'Type': client?.customerObj?.isCorporateAccount ? "CORP" : "GIG",
          'Payment method': client?.customerObj?.paymentMethod.split('_').join(' ') ?? '-',
          'Invoice No': client?.invoiceNumber ?? 0,
          'Amount': '$' + (handleAmountonUI(client?.invoiceAmount ?? 0)),
          'Status': client?.status ?? 0,
          'Reason': 'NA',
        };
      });
 
      worksheetData.push({
        'Item': 'Total',
        'Customer ID': '',
        'Customer Name': '',
        'Company name': '',
        'Type': '',
        'Payment method': '',
        'Invoice No': '',
        'Amount': '$'+this.totalArrearsAmount,
        'Status': '',
        'Reason': '',
      });
 
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(worksheetData);
 
      // Set column widths
      worksheet['!cols'] = [
        { wch: 10 }, // Index
        { wch: 15 }, // Customer ID
        { wch: 30 }, // Customer Name
        { wch: 30 }, // Company Name
        { wch: 15 }, // Type
        { wch: 20 }, // Payment method
        { wch: 20 }, // Invoice Number
        { wch: 15 }, // Amount
        { wch: 15 }, // Status
        { wch: 30 }, // Reason if avail
      ];
 
      const workbook: XLSX.WorkBook = {
        Sheets: { 'Arrears Report': worksheet },
        SheetNames: ['Arrears Report']
      };
 
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const fileName = `Arrears_Report_${new Date().toISOString().slice(0, 10)}.xlsx`;
      this.saveAsExcelFile(excelBuffer, fileName);
    }
 

  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName);
  }

  formatDate(date:any){
    return moment(date).format('YYYY-MM-DD')
  }
}